import React from "react";
import { Form, Formik } from "formik";
import CustomInputField from "../components/CustomInputField";
import { oxygenRetailSchema2 } from "../utils/formValidationSchema";
import { useDispatch, useSelector } from "react-redux";
import { setCustomermsisdn } from "../redux/features/oxygen/oxygenRetailSlice";
import useCustomAlert from "../components/Alert2";
import {setPreCustomerId} from "../redux/features/oxygen/oxygenRetailSlice";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import { setShowModal } from '../redux/features/oxygen/customModalSlice';
import PageWrapper from "../layouts/Index";
import PageTitle from "../components/PageTitle";
import { useNavigate } from "react-router-dom";
import { oxygenSecondCustomerDetails } from "../services/oxygenRetailServices";

const OxygenRetailForm2 = () => {
      const dispatch = useDispatch();
      const customAlert = useCustomAlert();
      const navigate = useNavigate();
      const precustomer = useSelector((state) => state?.precustomer?.precustomerData) || [];
      const employmentStatus = precustomer?.precustomer?.employmentStatus;
      const msisdn = precustomer?.precustomer?.msisdn
    
      const initialValues = {
        nin: "",
        nameOfEmployer: "",
        salaryAmount: "",
        salaryDay: "",
      };
    
      const handleSubmit = async (values) => {

        const formData = {
          nin: String(values.nin),
          nameOfEmployer: values.nameOfEmployer,
          salaryAmount: String(values.salaryAmount),
          salaryDate: Number(values.salaryDay) || 0,
          id: Number(precustomer?.precustomer?.precustomerId)
        };
    
        const res = await oxygenSecondCustomerDetails(formData);
        console.log("Oxygen Second Customer Details Response:", res);
        const precustomerPayload = {
          precustomer: {
            ...precustomer?.precustomer,
            nin: formData?.nin,
            employerName: formData?.nameOfEmployer,
            salaryAmount: formData?.salaryAmount,
            salaryDate: formData?.salaryDate,
          }
        };
    
        if(res?.status === true) {
          dispatch(setCustomermsisdn(res?.data));
          dispatch(setPreCustomerId(res?.preCustomerId));
          dispatch(updatePrecustomer({
            ...precustomerPayload,
            onboarding_status: "validate-otp-oxygen"
          }));
          customAlert.showToast("success", `Customer details submitted successfully, ${res?.message}`); 
    
          navigate('/oxygenForm-OTP');
          
        }else if(res?.status === false && res?.responseCode === "Pending") {
          customAlert.showToast("error", `${res?.message}` || "Your request is pending manual review.");
          dispatch(updatePrecustomer(precustomerPayload));
          // manual review modal
          dispatch(setShowModal({
            status:true,
            title:"Manual Review",
            type:"manualReview",
            showCloseButton:false,
            data:{message:res?.message, msisdn:msisdn},
          }));
        }else {
          customAlert.showToast("error", `${res?.message}` || "Failed to submit customer details");
        }
    
      };

  return (
    <PageWrapper>
      <PageTitle title={`Prequalification Form`} />
      <div className="row">
        <div className="col-xl-6 col-lg-8 col-md-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Oxygen Customer</h4>
            </div>
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                validationSchema={oxygenRetailSchema2(employmentStatus)}
                onSubmit={(values) => handleSubmit(values)}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleBlur,
                  handleChange,
                  isSubmitting,
                  setFieldValue,
                  handleSubmit,
                }) =>{
                  const isUnemployed = employmentStatus === "UNEMPLOYED";
                  const isSelfEmployed = employmentStatus === "SELF_EMPLOYED";
                  const isEmployed = employmentStatus === "EMPLOYED";

                  return(
                  <Form>
                    <div className="row mb-2">
                      <div className="col-sm-12">
                        <CustomInputField
                          label="NIN"
                          placeholder="Enter Your NIN"
                          name="nin"
                          type="number"
                          value={values.nin}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.nin}
                          touched={touched.nin}
                        />
                      </div>
                    </div>

                    {
                        !isUnemployed && (
                            
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <CustomInputField
                                label="Name of Employer"
                                placeholder="Enter Name of Employer"
                                name="nameOfEmployer"
                                value={values.nameOfEmployer}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.nameOfEmployer}
                                touched={touched.nameOfEmployer}
                                required={isEmployed ? true  : isSelfEmployed ? true : false}
                                />
                            </div>
                        </div>
                        )
                    }
                    {
                       isEmployed && (
                           <>
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <CustomInputField
                                    label="Salary Amount"
                                    placeholder="Enter Salary Amount"
                                    name="salaryAmount"
                                    type="number"
                                    value={values.salaryAmount}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.salaryAmount}
                                    touched={touched.salaryAmount}
                                    required={isEmployed? true : false}
                                    />
                                </div>
                            </div>
                            <div className="row mb-2">
                            <div className="col-sm-12">
                                <CustomInputField
                                label="Salary Date (e.g 29)"
                                placeholder="Enter Salary Day"
                                name="salaryDay"
                                type="number"
                                value={values.salaryDay}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.salaryDay}
                                touched={touched.salaryDay}
                                readOnly={isUnemployed ? true : isSelfEmployed ? true : false}
                                required={isEmployed ? true : false}
                                />
                            </div>
                            </div>
                           </>
                       ) 
                    }


                    <div className="d-flex justify-content-end align-items-center">
                        <button
                        type="submit"
                        className="btn btn-primary btn-lg"
                        disabled={isSubmitting}
                        >
                        {isSubmitting ? "Please wait..." : "Submit"}
                        </button>
                    </div>
                  </Form>
                )}
              }
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}

export default OxygenRetailForm2